import { Controller } from "@hotwired/stimulus";
import HSFormSearch from "../theme/hs-form-search.min";

export default class SearchController extends Controller {
  static values = {
    delay: { type: Number, default: 500 },
    url: String,
    shouldSubmit: Boolean,
  };

  connect() {
    this.element.querySelector(".comic-search__toggle")
      ?.addEventListener("click", () => this.toggle());

    this.lastInputValue = null;
    this.formSearch = new HSFormSearch(this.element).getItem(0);
    this.searchTimeout = null;

    this.formSearch.events = this?.formSearch?.events || {};

    this.formSearch.events.clear = () => {
      if ($("#search_users").length) {
        $("#search_users").html("<span class='text-white'>No results found!</span>");
      }
      this.#updateLinks("");
      this.#call();
    };

    this.handleInput = () => this.#call();
    this.handleKeydown = (event) => {
      if (event.key === "Enter" && this.hasUrlValue && !this.shouldSubmitValue && !event.isComposing) {
        event.preventDefault();
        this.#call();
      }
    };
    this.formSearch.$el.addEventListener("input", this.handleInput);
    this.formSearch.$el.addEventListener("keydown", this.handleKeydown);
    $(this.formSearch.$el).on("change", () => {
      this.formSearch.loading(false);
    });
    this.formSearch.on("clear", () => {
      this.#updateLinks("");
      this.#call();
    });
  }

  disconnect() {
    this.cancelPendingSearch();
    this.formSearch.$el.removeEventListener("input", this.handleInput);
    this.formSearch.$el.removeEventListener("keydown", this.handleKeydown);
  }

  #call() {
    const normalizedValue = this.formSearch.$el.value.trimStart();
    this.formSearch.$el.value = normalizedValue;
    const value = normalizedValue.trim();

    if (this.scheduledSearchValue === value) return;
    this.scheduledSearchValue = value;
    this.searchVersion = (this.searchVersion || 0) + 1;

    this.#updateLinks(value);
    this.formSearch.loading(true);

    clearTimeout(this.searchTimeout);
    this.searchTimeout = setTimeout(async () => {
      await this.#search(value);
      this.formSearch.loading(false);
    }, this.delayValue);
  }

  cancelPendingSearch() {
    clearTimeout(this.searchTimeout);
    this.searchVersion = (this.searchVersion || 0) + 1;
    this.scheduledSearchValue = null;
    this.hasMessageSearchResults = false;
    this.formSearch.loading(false);
  }

  async #search(search_txt) {
    if (this.shouldSubmitValue) {
      this.element.closest("form")?.requestSubmit();
      return;
    }

    this.#updateLinks(search_txt);
    if (!this.hasUrlValue) return;
    if (this.lastInputValue === search_txt) return;

    const isMessageSearch = this.element.classList.contains("message-search");
    const version = this.searchVersion = (this.searchVersion || 0) + 1;

    const turboRequest = (await import("../helpers/api")).turboRequest;

    if (version !== this.searchVersion) return;
    try {
      const result = await turboRequest(this.urlValue + encodeURIComponent(search_txt), {
        method: "GET",
        turboStream: true,
        renderTurboStream: false,
        onSuccess: (_, response) => {
          if (!response.headers.get("Content-Type")?.includes("text/vnd.turbo-stream.html")) {
            throw new Error("Unexpected search response");
          }
        },
      });
      if (version === this.searchVersion && this.element.isConnected) {
        this.lastInputValue = search_txt;
        if (isMessageSearch) this.hasMessageSearchResults = Boolean(search_txt);
        Turbo.renderStreamMessage(result);
      }
    } catch (error) {
      if (version !== this.searchVersion || !this.element.isConnected) return;
      this.scheduledSearchValue = null;
      this.lastInputValue = null;
      const results = this.element.closest(".search-bar")?.querySelector("#search_users");
      if (results) {
        const message = document.createElement("p");
        message.className = "text-white p-2 mb-0";
        message.setAttribute("role", "status");
        message.textContent = "Search is temporarily unavailable. Please try again.";
        results.replaceChildren(message);
      }
    }
  }

  #updateLinks(searchTxt) {
    for (const link of document.querySelectorAll("#searchPosts a")) {
      const url = new URL(link.href);

      if (searchTxt) {
        url.searchParams.set("search", searchTxt);
      } else {
        url.searchParams.delete("search");
      }

      link.href = url.toString();
    }
  }
}
